import { SimpleFormView, TabbedForm } from "react-admin";
import { DefaultToolbar } from "..";

SimpleFormView.defaultProps.toolbar = <DefaultToolbar />;
TabbedForm["defaultProps"] = TabbedForm["defaultProps"] || {};
TabbedForm["defaultProps"].toolbar = <DefaultToolbar />;